import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { environment } from 'config';
import { Store } from 'components/common/types/Store.types';

export const calculateLoadTime = (startTime?: number): number => {
  if (!startTime) return 0;
  return performance.now() - startTime;
};

const getNetworkSpeed = (): 'UNKNOWN' | 'SLOW' | 'MEDIUM' | 'FAST' => {
  const { downlink } = navigator.connection ?? {};

  if (downlink == null) return 'UNKNOWN';
  if (downlink < 1) return 'SLOW';
  if (downlink < 5) return 'MEDIUM';
  return 'FAST';
};

export const useLogPerformance = (): ((
  description: string,
  loadTimeInMs: number,
  additionalInfo?: Record<string, string | number>,
) => void) => {
  const marketID = useSelector((state: Store) => state.environment.environmentId);
  const campaignType = useSelector((state: Store) => state.dealManagement.campaignType);

  return useCallback(
    (description: string, loadTimeInMs: number, additionalInfo?: Record<string, string | number>) => {
      const payload = {
        market: marketID,
        environmentId: environment,
        networkSpeedInMbps: getNetworkSpeed(),
        loadTimeInMs: Math.trunc(loadTimeInMs),
        tradingType: campaignType ?? null,
        ...additionalInfo,
      };
      const actionName = `UI Performance - ${description}`;
      datadogRum.addAction(actionName, payload);
      datadogLogs.logger.info(actionName, payload);
    },
    [campaignType, marketID],
  );
};
